/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceMappingResponse {
    getFixupPrototypeFunction() { return ComplianceMappingResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceMappingResponse>): ComplianceMappingResponse {
        let obj = Object.assign(new ComplianceMappingResponse(), model);
        ComplianceMappingResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceMappingResponse>): ComplianceMappingResponse {
        if (!model) return null;
        return ComplianceMappingResponse.newInstance(<ComplianceMappingResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceMappingResponse) {
        if (!obj) return;

        models.ComplianceMappingResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceMappingResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceMappingResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * success
     */
    status: string;

    /**
     * compliance control mappings list
     */
    message: string;

    /**
     * Total count
     */
    total_count: string;

    /**
     * page count
     */
    page_count: string;

    /**
     * compliance control mappings list.
     */
    data: any;

}
